import React, { Component, Fragment } from 'react'
import Breadcrumb from 'react-bootstrap/Breadcrumb'
import { Link } from 'react-router-dom';
import { Container,Row,Col,Button} from 'react-bootstrap'
import Product1 from '../../assets/images/product/tradehub.png'




class TradeHub extends Component {
     render() {
          return (
               <Fragment>
              <Container fluid={true}  className="BetweenTwoSection">
                  <div className="breadbody">
                <Breadcrumb>
  <Breadcrumb.Item> <Link to="/"> Home </Link> </Breadcrumb.Item>
    <Breadcrumb.Item> <Link to="/products"> Product </Link> </Breadcrumb.Item>
  <Breadcrumb.Item> <Link to="/tradehub"> tradehub </Link> </Breadcrumb.Item>   
</Breadcrumb>
</div>

<div className="d-flex justify-content-between align-items-center mb-2">
  <h2 className="section-title text-primary m-0"></h2>

 
    <Link to="/tradehublive">
               
               
          
             <Button size="sm" variant="primary">
                  Live Demo
             </Button>
             </Link>
</div>



<h2 className="section-title text-center mb-2 text-primary"><strong>TRADE HUB </strong></h2>
   

<p className="text-center mb-3">Purchasing, Sales, and Inventory Management Software</p>



                   <Row className="p-2">
<Col className="shadow-sm bg-white pb-3 mt-4" md={12} lg={12} sm={12} xs={12}>
     <Row>
          <Col className="p-3" md={6} lg={6} sm={12} xs={12}>
    <img  className="product-main"  src={Product1}  alt="ParkEase Dashboard"/>
          <Container  className="my-3">
               
          </Container>
          </Col>
          <Col className="p-3 " md={6} lg={6} sm={12} xs={12}>
          <h5 className="Product-Name">TRADE HUB </h5>
          
          <p>is a business management software designed to control purchasing, stock, and sales operations efficiently. It supports two main users:
                Admin and Cashier, each with specific responsibilities to ensure proper stock control and approval processes.</p>
          <div className="">
           <h6> Trade hub has two main types of users:</h6>
          <p>
               <li>Admin (Administrator)</li>
              <li>Cashier</li>
               </p>
               <h5>How the System Works</h5>
          <h6>Admin creates and manages cashiers</h6>
          <p>The Admin can add users (cashiers) into the system and assign responsibilities.</p>

          <h6>Admin purchases items (stock)</h6>
          <p>The Admin buys items from suppliers and records them in the system.</p>


            <h6>Cashier requests items</h6>
          <p>The Cashier selects items needed for sale and sends a purchase request to the Admin.</p>


            <h6>Admin approves the request</h6>
          <p>The Admin reviews and approves the requested items.</p>



            <h6>Stock increases after purchase</h6>
          <p>When items are purchased and approved, the stock quantity automatically increases in the system.</p>

            <h6>Cashier sells items</h6>
          <p>The Cashier sells items to customers using the system.</p>
          <h6>Stock decreases after sale</h6>
          <p>Each sale automatically reduces the stock quantity.</p>


          </div>
          </Col>
     </Row>

     <Row>
          <Col className="" md={6} lg={6} sm={12} xs={12}>
          <h6 className="mt-2">Key Features of TRADE HUB</h6>
          <ul>
          <li>Purchase Management</li>
           <li>Sales Management</li>
          <li>Sales Management</li>
          <li>Admin Approval Workflow</li>
          <li>User Management (Admin & Cashier)</li>
          <li>Real-time Stock Updates</li>
          <li>Business Reporting</li>
          <li>Secure Role-Based Access</li>
          </ul>
          </Col>

          <Col className="" md={6} lg={6} sm={12} xs={12}>
          <h6 className="mt-2">REVIEWS</h6>
          <h6>Improves Business Efficiency</h6>
        <p>
  “This software reduced manual work in our shop.
  We can track inventory, sales, and purchases instantly.
  It helps prevent stock shortages and overstocking.”
</p>
         <p>Real-time tracking is one of the main benefits of
           inventory software because it allows businesses to quickly identify low stock and avoid losses from stockouts</p>

          <h6>Secure and Controlled Workflow</h6>
          <p>“We like the approval system. The cashier sends requests, and the admin approves them before purchasing.
                This prevents mistakes and improves control over spending.”</p>
          </Col>
     </Row>

</Col>
                   </Row>
               </Container>
               
               </Fragment>
          )
     }
}

export default TradeHub